export default function retrySearch({ state }) {
  if (state.search.retriesCount > 1) {
    window.location.reload();
  }
}
